<template>
  <a-card :bordered="false" :bodyStyle="{padding:'20px'}" :headStyle="{borderBottom:'0px',paddingLeft:'20px'}">
    <a-row slot="title">
      <a-col :span="8">
        <span class="card-title">公司新闻</span>
      </a-col>
      <a-col :span="8" :offset="8" style="text-align:right;">
        <a-button type="primary" @click="handleContent(0)">添加新内容</a-button>
      </a-col>
    </a-row>
    <custom-paging-dragging-list
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      @draggable="onDraggable"
    >
      <div slot="indexSlots" slot-scope="rowItem">{{ rowItem.index + 1 }}</div>
      <div slot="action" slot-scope="rowItem">
        <a @click="handleContent(rowItem.record.id)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          title="你确定要删除这行内容吗?"
          @confirm="deleteEvent(rowItem.record)">
          <a-icon slot="icon" type="close-circle" style="color: red"/>
          <a>删除</a>
        </a-popconfirm>
      </div>
    </custom-paging-dragging-list>
  </a-card>
</template>

<script>
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'CompanyNews',
  components: {
    CustomPagingDraggingList
  },
  data() {
    return {
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' },
          width: '70px'
        },
        {
          title: '标题',
          dataIndex: 'title'
        },
        {
          title: '修改时间',
          dataIndex: 'gmtModified'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getModularListPromise(params),
      queryParams: {}
    }
  },
  mounted() {
  },
  activated() {
    this.$refs.table.refresh(true)
  },
  methods: {
    handleContent(id) {
      let params = {}
      if (id) {
        params.id = id
      }
      this.openNewPage('AddCompanyNews', params)
    },
    // 删除
    deleteEvent(item) {
      this.getHttpServices().getUserService().post('pc/v2/corporation-news/delete/' + item.id)
        .then(res => {
          this.$message.success('成功删除')
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 拖拽排序功能
    onDraggable(params) {
      let idList = []
      idList = params.dataList.map((item) => {
        return item.id
      })
      this.getHttpServices().getUserService().post('pc/v2/corporation-news/orderBy', {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList
      }).then(res => {
        this.$message.success('排序成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getModularListPromise(params) {
      return this.getHttpServices().getUserService().post('pc/v2/corporation-news/query', params)
    }
  }
}
</script>

<style lang="less">
</style>